import { Outlet } from "react-router";

export const Activities = () => {
  return <Outlet />;
};
